import BusinessCharacteristicModelBase from '../_generated/modelBases/business-characteristic-model-base';

export default class BusinessCharacteristicModel extends BusinessCharacteristicModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
